export const CONFIG_AND_SERVICES_LOADED = 'config-and-services-loaded';
